<svg
  width="21px"
  height="21px"
  viewBox="0 0 21 21"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  aria-labelledby="edit-icon-title edit-icon-desc"
  role="img"
>
  <title id="edit-icon-title">Edit icon</title>
  <desc id="edit-icon-desc">This is a pencil icon depicting editing.</desc>
  <g
    id="Page-1"
    stroke="none"
    stroke-width="1"
    fill="none"
    fill-rule="evenodd"
    stroke-linejoin="round"
  >
    <g
      id="13_Customers---Detail"
      transform="translate(-811.000000, -406.000000)"
      stroke="#26478D"
      class="stroke"
    >
      <g
        id="Edit"
        transform="translate(812.000000, 406.000000)"
      >
        <path
          d="M4.33443,19.1687 C3.9386,18.3632 3.41648,17.6231 2.76493,16.9715 C2.12846,16.3351 1.40717,15.8217 0.62305,15.4297"
          id="Path"
        ></path>
        <path
          d="M18.9114,5.02855 C18.9114,5.02855 19.3933,4.54664 18.8938,4.04714 L15.8949,1.04762 C15.8949,1.04762 15.3948,0.548118 14.9129,1.03003 L1.65256,14.2904 L0.04599,19.4487 C-0.180201,20.1304 0.50151,19.9042 0.50151,19.9042 L5.64919,18.2908 L18.9114,5.02855 Z"
          id="Path"
          stroke-linecap="round"
        ></path>
      </g>
    </g>
  </g>
</svg>
